import * as tslib_1 from "tslib";
import { OnInit, EventEmitter } from '@angular/core';
import { ControlValueAccessor } from '@angular/forms';
import { NgbModal } from '../../../../../../node_modules/@ng-bootstrap/ng-bootstrap';
import { FileViewerComponent } from '../file-viewer/file-viewer.component';
import { UserService } from '../../../services/user.service';
import { VsFileItem } from '../../file-upload/models/file-item';
import { VsFileUploadService } from '../services/file-upload.service';
import { DialogService } from 'primeng/primeng';
import { ComponentBase } from '../../../classes/base/component-base';
import { FileType } from '../../../../dapfood/common/constant';
import { DocumentViewerComponent } from '../document-viewer/document-viewer.component';
var VsFsListFileComponent = /** @class */ (function (_super) {
    tslib_1.__extends(VsFsListFileComponent, _super);
    function VsFsListFileComponent(_fileService, ngbModal, _userService, dialogService) {
        var _this = _super.call(this) || this;
        _this._fileService = _fileService;
        _this.ngbModal = ngbModal;
        _this._userService = _userService;
        _this.dialogService = dialogService;
        _this.files = [];
        _this.disabled = false;
        _this.ids = [];
        _this.linkView = '';
        _this.selectedFile = new VsFileItem();
        _this.currentIds = '';
        _this.isMngFile = false;
        _this.viewOnly = false;
        _this.isSingleFile = false;
        _this.onUploaded = new EventEmitter();
        _this.onRemoved = new EventEmitter();
        _this.onClick = new EventEmitter();
        _this.onSelectItem = new EventEmitter();
        _this.onChangeControl = function (obj) { };
        _this.onTouched = function () { };
        return _this;
    }
    VsFsListFileComponent.prototype.ngOnInit = function () {
        this.userId = this._userService.getBasicUserInfo().userId;
    };
    VsFsListFileComponent.prototype.writeValue = function (obj) {
        if (obj) {
            this.files = obj;
        }
    };
    VsFsListFileComponent.prototype.registerOnChange = function (fn) {
        this.onChangeControl = fn;
    };
    VsFsListFileComponent.prototype.registerOnTouched = function (fn) {
        this.onTouched = fn;
    };
    VsFsListFileComponent.prototype.setDisabledState = function (isDisabled) {
        this.disabled = isDisabled;
    };
    VsFsListFileComponent.prototype.openFile = function (item) {
    };
    VsFsListFileComponent.prototype.deleteFile = function (item) {
        if (item.isFolder === true) {
            this._fileService.deleteFolder(this.userId, item.id);
            var fileToRemove = this.files.findIndex(function (x) { return x.fileName === item.fileName; });
            this.files.splice(fileToRemove, 1);
        }
        else {
            this._fileService.deleteFile(item);
            var fileToRemove = this.files.findIndex(function (x) { return x.fileName === item.fileName; });
            this.files.splice(fileToRemove, 1);
            this.onChangeControl(this.files);
            this.onRemoved.next(item);
        }
    };
    VsFsListFileComponent.prototype.deleteFileTemp = function (item) {
        if (item.isFolder === true) {
            var fileToRemove = this.files.findIndex(function (x) { return x.fileName === item.fileName; });
            this.files.splice(fileToRemove, 1);
        }
        else {
            var fileToRemove = this.files.findIndex(function (x) { return x.fileName === item.fileName; });
            this.files.splice(fileToRemove, 1);
            this.onChangeControl(this.files);
            this.onRemoved.next(item);
        }
    };
    VsFsListFileComponent.prototype.viewFile = function (item) {
        if (item.type == FileType.Image || item.type == FileType.Video) {
            this.ref = this.dialogService.open(FileViewerComponent, {
                data: {
                    file: item,
                },
                showHeader: false,
                width: '100%',
                height: 'calc(100vh)',
                styleClass: "vs-modal",
                contentStyle: { 'overflow': 'auto', 'position': 'relative' },
                baseZIndex: 1100,
                closeOnEscape: true,
            });
        }
        else {
            this.ref = this.dialogService.open(DocumentViewerComponent, {
                data: item,
                showHeader: true,
                header: item.fileName,
                width: '100%',
                height: 'calc(100vh - 0px)',
                styleClass: "vs-modal vs-file-viewer",
                contentStyle: { 'overflow': 'auto' },
                baseZIndex: 1100,
                closeOnEscape: true
            });
        }
    };
    VsFsListFileComponent.prototype.onItemClick = function (item) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                this.selectedFile = new VsFileItem();
                if (item.isFolder === true) {
                    this.onChangeControl(this.files);
                    this.onClick.next(item);
                }
                else {
                    this.viewFile(item);
                }
                return [2 /*return*/];
            });
        });
    };
    VsFsListFileComponent.prototype.checkItem = function (item) {
        if (this.isSingleFile) {
            this.files.forEach(function (element) {
                if (element.id !== item.id) {
                    element.checked = false;
                }
            });
            if (item.checked) {
                this.ids = [];
                this.ids.push(item.id);
                item.checked = true;
            }
            else {
                this.ids.splice(this.ids.indexOf(item.id), 1);
                item.checked = false;
            }
            this.onChangeControl(this.ids);
            this.onSelectItem.next(this.ids + '');
        }
        else {
            this.ids = this.currentIds.split(',').filter(function (s) { return s !== ''; });
            if (item.checked) {
                // Kiểm tra nếu Id chưa có trong currentIds thì bổ sung
                if (this.currentIds.indexOf(item.id + ',') < 0 && this.currentIds.indexOf(',' + item.id) < 0) {
                    this.ids.push(item.id);
                    item.checked = true;
                    this.onSelectItem.next(this.ids + ',');
                }
            }
            else {
                // Kiểm tra nếu Id có trong currentIds thì remove để xóa
                this.currentIds = this.currentIds.replace(item.id + ',', '');
                this.currentIds = this.currentIds.replace(',' + item.id, '');
                this.ids.splice(this.ids.indexOf(item.id), 1);
                item.checked = false;
                this.onSelectItem.next(this.currentIds);
            }
            this.onChangeControl(this.ids);
        }
        // alert(this.ids + this.currentIds);
    };
    VsFsListFileComponent.prototype.onClose = function () {
        this.modalReference.close();
    };
    return VsFsListFileComponent;
}(ComponentBase));
export { VsFsListFileComponent };
